const WIDE_SINGLE_COLUMN_CONTENT_WIDTH = '780px';

export default WIDE_SINGLE_COLUMN_CONTENT_WIDTH;
